import { useMemo, useState } from "react";

// param allData cho phân trang bên client
export const usePagination = (allData) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangePageSize = (newPageSize) => {
    setPage(1);
    setPageSize(newPageSize);
  };
  const skip = (page - 1) * pageSize;
  const limit = pageSize;

  const clientData = useMemo(
    () => allData?.slice(skip, skip + limit),
    [allData, limit, skip]
  );

  return {
    page,
    pageSize,
    handleChangePage,
    handleChangePageSize,
    skip,
    limit,
    clientData,
    clientTotal: allData?.length || 0,
  };
};
